import { PaginatedImageSearchResponse } from '@business/entities/image_finder';
import { Endpoint } from '../endpoint';
import { ImageFinderData } from '@modules/ImageFinder/ImageFinderModal';

interface Query extends ImageFinderData {
  page: number;
}

export function fetchImages(data: Query) {
  return Endpoint.get<PaginatedImageSearchResponse>(`@gc/image-finder`, { params: data });
}
